<template>
  <bkf-icon :class="state">
    <v-tooltip
      v-if="content"
      bottom
    >
      <template #activator="{ on, attrs }">
        <!-- eslint-disable max-len -->
        <svg
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;"
          v-bind="attrs"
          v-on="on"
        >
          <g>
            <g>
              <path
                d="M338.722,115.086c-6.343-3.732-14.513-1.611-18.244,4.733s-1.613,14.513,4.733,18.244
              c41.646,24.492,67.517,69.683,67.517,117.937c0,75.394-61.335,136.729-136.729,136.729c-75.393,0-136.729-61.337-136.729-136.729
              c0-48.254,25.87-93.445,67.517-117.937c6.345-3.73,8.464-11.899,4.733-18.244c-3.73-6.345-11.898-8.462-18.244-4.733
              C123.523,144.347,92.616,198.342,92.616,256c0,90.091,73.293,163.384,163.384,163.384S419.384,346.091,419.382,256
              C419.382,198.343,388.475,144.347,338.722,115.086z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M256,74.832c-7.361,0-13.328,5.968-13.328,13.328V256c0,7.361,5.967,13.328,13.328,13.328
              c7.361,0,13.328-5.967,13.328-13.328V88.16C269.328,80.801,263.361,74.832,256,74.832z"
              />
            </g>
          </g>
        </svg>
      </template>
      <span>{{ content }}</span>
    </v-tooltip>
  </bkf-icon>
</template>

<script>
import human from '@utils/human';

export default {
  props: {
    seconds: {
      default: null,
      required: false,
      type: Number,
    },
    state: {
      default: null,
      required: false,
      type: String,
    },
  },
  computed: {
    content() {
      return this.$trans(
        'device.indicator.enabled-time',
        this.state === null ? t`v2.i2m_components.no-data` : `${human(this.seconds)}`,
      );
    },
  },
};
</script>
